import { useFetchWrapper } from 'helpers';
import { Action } from 'states';
import { APIS } from '../constants';

export { useActionsService };

const useActionsService = () => {
  const baseUrl = `${process.env.REACT_APP_BASE_API_URL}`;
  const fetchWrapper = useFetchWrapper();

  const getAllActions = () => {
    return fetchWrapper.get<Action[]>(new URL(`${baseUrl}${APIS.ACTIONS.GET_ALL_ACTIONS}`));
  };

  const getActionsForRole = (roleId: number) => {
    return fetchWrapper.get<Action[]>(new URL(`${baseUrl}${APIS.ACTIONS.GET_ACTIONS_FOR_ROLE}${roleId}`));
  };

  return { getAllActions, getActionsForRole };
};
